import { EventEmitter, Injectable } from '@angular/core';
import { BaseSiteService, GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ReturnService {
  public userAccountInfo = new BehaviorSubject<any>(null);
  public paginationValues = new BehaviorSubject<any>(null);
  paginationValues$ = this.paginationValues.asObservable();
  public emitPaginationValue = new BehaviorSubject<any>(null);
  emitPaginationValue$ = this.emitPaginationValue.asObservable();
  public returnsList = new BehaviorSubject<any>(null);
  returnsList$ = this.returnsList.asObservable();
  public returnStatus = new BehaviorSubject<any>(null);
  returnStatus$ = this.returnStatus.asObservable();
  public updateShipping = new BehaviorSubject<any>(null);
  updateShipping$ = this.updateShipping.asObservable();
  public returnInfo = new BehaviorSubject<any>(null);
  returnInfo$ = this.returnInfo.asObservable();
  public emitReturnHistory = new EventEmitter();

  constructor(
    private readonly baseService: BaseService,
    private baseSiteService: BaseSiteService,
    private readonly globalMessage?: GlobalMessageService
  ) { }

  public postSubmitRequest(params, userId): Observable<any> {
    return this.baseService.post(
      `/users/${userId}/orderReturns/submitReturn`,
      params
    );
  }

  public getFile(userId, returnKey): Observable<any> {
    return this.baseService.getPdf(
      `/users/${userId}/orderReturns/downloadPdf/${returnKey}`
    );
  }
  public setPaginationValues(data) {
    this.paginationValues.next(data);
  }

  public emitPagination(data) {
    this.emitPaginationValue.next(data);
  }

  public getReturnsHistory(userId, filters): Observable<any> {
    return this.baseService
      .get(`users/${userId}/orderReturns/returnhistory`, filters)
    // .subscribe((res) => {
    //   this.returnsList.next(res);
    // });
  }

  public getReturnStatus(userId, returnKey): Observable<any> {
    return this.baseService
      .post(`users/${userId}/orderReturns/updateReturnStatus/${returnKey}`, '')
    // .subscribe((res) => {
    //   this.returnStatus.next(res);
    // });
  }

  public updateShippingBox(userId, param): Observable<any> {
    return this.baseService
      .post(`users/${userId}/orderReturns/updateShippingBox`, param);
    // .subscribe((res) => {
    //   this.updateShipping.next(res);
    // });
  }

  public downloadReturnInfo(userId, returnKey,): Observable<any> {
    return this.baseService.getPdf(
      `users/${userId}/orderReturns/downloadRetInfo/${returnKey}?b2bUnitId=${JSON.parse(localStorage.getItem('accountId'))}&fields=DEFAULT`
    );
  }

  public returnInformation(userId, returnKey): void {
    let params = {
      fields: 'DEFAULT',
    };
    this.baseService
      .post(
        `users/${userId}/orderReturns/returnInformation/${returnKey}`,
        params
      )
      .subscribe((res) => {
        this.returnInfo.next(res);
      });
  }

  public downloadPdf(params): void {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_CREDIT_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }, error => {
        this.globalMessage.add('Requested document is not available at this moment', GlobalMessageType.MSG_TYPE_ERROR);
      });
  }

}
